import { render } from "./navlink.vue?vue&type=template&id=0d4573ec&scoped=true&ts=true"
import script from "./navlink.vue?vue&type=script&lang=ts"
export * from "./navlink.vue?vue&type=script&lang=ts"

import "./navlink.vue?vue&type=style&index=0&id=0d4573ec&lang=css"
import "./navlink.scss?vue&type=style&index=1&id=0d4573ec&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4573ec"]])

export default __exports__